import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-32 text-center">
      <div className="eyebrow text-muted-foreground">Error 404</div>
      <h1 className="font-serif text-7xl font-black tracking-tight mt-3">Page not found.</h1>
      <p className="mt-4 text-muted-foreground">The essay you're looking for has been moved, deleted, or never existed.</p>
      <Link to="/" className="mt-8 inline-flex items-center gap-2 px-6 py-3 bg-foreground text-background hover:bg-foreground/90" data-testid="notfound-home-link">Back home</Link>
    </div>
  );
}
